import React from 'react';
import { MailIcon, MessageSquareIcon, PhoneIcon } from 'lucide-react';
import { Modal } from './Modal';
import { TaskList } from './TaskList';
import { formatAmount, type Lead } from '../data/mockData';
type LeadModalProps = {
  lead: Lead | null;
  onClose: () => void;
};
function Field({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div data-id="element-117" data-mp="b201jiymaatf">
      <dt className="text-[11px] uppercase tracking-wide text-gray-400" data-id="element-118" data-mp="b1glk7sj1wi1">{label}</dt>
      <dd className="mt-0.5 text-[13px] text-ink" data-id="element-119" data-mp="3t84pvvfr6fmn">{value}</dd>
    </div>;
}
export function LeadModal({
  lead,
  onClose
}: LeadModalProps) {
  return <Modal open={Boolean(lead)} onClose={onClose} title={lead ? lead.name : ''} subtitle={lead ? `${lead.state} · ${formatAmount(lead.amount)} · ${lead.stage}` : undefined} footer={<div className="flex flex-wrap gap-2" data-id="element-121" data-mp="1hkeu0g9mk7zj">
          <button type="button" className="inline-flex items-center gap-1.5 rounded-lg bg-brand px-3 py-2 text-[12.5px] font-semibold text-white transition-colors hover:bg-brand-dark" data-id="element-122" data-mp="1miq3gpw0cgh8">
            <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-123" data-mp="2mkv6lj5v5rsd" />
            Call now
          </button>
          <button type="button" className="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-2 text-[12.5px] font-medium text-ink transition-colors hover:bg-gray-50" data-id="element-124" data-mp="317y2jlejfsdl">
            <MessageSquareIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-125" data-mp="28kkao1pp5n0c" />
            Text
          </button>
          <button type="button" className="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-2 text-[12.5px] font-medium text-ink transition-colors hover:bg-gray-50" data-id="element-126" data-mp="23nk7byk8eycx">
            <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-127" data-mp="3szm9fsejrmp1" />
            Email
          </button>
        </div>} data-id="element-120" data-mp="3jbs0h9r8qnxp">
      {lead && <div className="space-y-5 px-5 py-4" data-id="element-128" data-mp="3oyalrsf8hbjh">
          <dl className="grid grid-cols-2 gap-4" data-id="element-129" data-mp="2lo66q0ar6grm">
            <Field label="Source" value={lead.source ?? '—'} data-id="element-130" data-mp="2lnen7nufk9hp" />
            <Field label="Loan purpose" value={lead.loanPurpose ?? '—'} data-id="element-131" data-mp="2qlogtu0ib217" />
            <Field label="Phone" value={lead.phone ?? '—'} data-id="element-132" data-mp="2vm3tejcys5i4" />
            <Field label="Email" value={lead.email ?? '—'} data-id="element-133" data-mp="2vmlupuehh9ww" />
            <Field label="Last touch" value={lead.lastTouch ?? '—'} data-id="element-134" data-mp="2znpa6fsmd3xl" />
            <Field label="Call cadence" value={lead.attempts ?? '—'} data-id="element-135" data-mp="22xf036i5h4gx" />
          </dl>

          <section data-id="element-136" data-mp="22vc0bur73wz0">
            <h3 className="mb-2 text-[12.5px] font-semibold text-ink" data-id="element-137" data-mp="27vzyr1hr7g39">Tasks</h3>
            <TaskList tasks={lead.tasks ?? []} data-id="element-138" data-mp="2bxv189bf7zim" />
          </section>

          <section data-id="element-139" data-mp="2bwjxualw0ts1">
            <h3 className="mb-2 text-[12.5px] font-semibold text-ink" data-id="element-140" data-mp="2bw0fissbs3dh">Next step</h3>
            <p className="rounded-lg border border-gray-200 px-3 py-2.5 text-[12.5px] text-gray-600" data-id="element-141" data-mp="2gpuwhogjq48v">
              {lead.detail}
            </p>
          </section>
        </div>}
    </Modal>;
}